class AssignReportSimulatorsController {
    constructor($window, toastr, ReportAccessServiceApi) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.state = {
                selectedReport: { Id: 0, Name: '' }
            };
            this.data = {
                assignedSimulators: [],
                availableSimulators: []
            };
            this.state.selectedReport = this.resolve.report;
            this.renderAssignedSimulators();
        };
        this.addSimulator = (simulator) => {
            let reportId = this.state.selectedReport.Id;
            let simId = simulator.Id;
            this.ReportAccessServiceApi.addSimulatorToReport(reportId, simId).then((reports_response) => {
                let resp = reports_response.data;
                if (resp) {
                    this.toastr.info('Simulator added to report.');
                    this.renderAssignedSimulators();
                }
                else {
                    this.toastr.error('Could not add simulator to report.');
                }
            });
        };
        this.removeSimulator = (simulator) => {
            let reportId = this.state.selectedReport.Id;
            let simId = simulator.Id;
            this.ReportAccessServiceApi.removeSimulatorFromReport(reportId, simId).then((reports_response) => {
                let resp = reports_response.data;
                if (resp) {
                    this.toastr.info('Simulator removed from report.');
                    this.renderAssignedSimulators();
                }
                else {
                    this.toastr.error('Could not remove simulator from report.');
                }
            });
        };
        this.renderAssignedSimulators = () => {
            this.ReportAccessServiceApi.getSimulatorsForReport(this.state.selectedReport.Id).then((reports_response) => {
                let resp = reports_response.data;
                this.data.assignedSimulators = resp.AssignedSimulators;
                this.data.availableSimulators = resp.AvailableSimulators;
            });
        };
        this.window = $window;
        this.toastr = toastr;
        this.ReportAccessServiceApi = ReportAccessServiceApi;
    }
}
angular.module('app').component('assignReportSimulatorsModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/Reports/assign-report-simulators.tpl.html',
    controllerAs: 'vm',
    controller: AssignReportSimulatorsController
});
